import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        edu_levels: [],
        images: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        edu_levelMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        getEdu_levelsRequest({dispatch}) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveEdu_levels", null);
            } else {
                dispatch("receivingEdu_levels"); // สถานะ กำลังบันทึก

                axios.get('/edu_levels').then(res => {

                    dispatch("receiveEdu_levels", res.data);
                })
                    .catch((e) => {
                        console.log(e);
                        dispatch("receiveEdu_levels", null);
                    })
            }
        },
        loadEdu_levelRequest({dispatch}, id) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveEdu_level", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingEdu_level");
                axios.get('/edu_levels/' + id).then(res => {
                    dispatch("receiveEdu_level", res.data);
                })
            }
        },
        updateEdu_levelRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingEdu_level");
            axios.put('/edu_levels/' + payload.edu_code, payload).then(res => {
                dispatch("updateEdu_level", res.data);
            })
        },
        createEdu_levelRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingEdu_level");
            axios.post('/edu_levels', payload).then(res => {
                dispatch("receiveEdu_level", res.data);
            })
        },
        deleteEdu_levelRequest({dispatch}, payload) {

            dispatch("afterDeleteEdu_level", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingEdu_level", payload);

            axios.post('/delete_edu_levels', payload).then(res => {
                dispatch("deleteEdu_level", {edu_code: payload.edu_code, res: res});
            })


        },
        receiveEdu_levels({commit}, payload) {
            commit("RECEIVED_EDU_LEVELS", payload)
        },
        receivingEdu_levels({commit}) {
            commit("RECEIVING_EDU_LEVELS") //call matutions --> state.isReceiving = true;
        },
        receiveEdu_level({commit}, payload) {
            commit("RECEIVED_EDU_LEVEL", payload)
        },
        receivingEdu_level({commit}) {
            commit("RECEIVING_EDU_LEVELS") //call matutions --> state.isReceiving = true;
        },
        updateEdu_level({commit}, payload) {
            commit("UPDATED_EDU_LEVEL", payload)
        },
        updatingEdu_level({commit}) {
            commit("UPDATING_EDU_LEVEL") //  call matutions --> state.isUpdating = true;
        },
        deleteEdu_level({commit}, payload) {
            commit("DELETED_EDU_LEVEL", payload)
        },
        deletingEdu_level({commit}, payload) {
            commit("DELETING_EDU_LEVEL", payload)
        },
        afterDeleteEdu_level({commit}, payload) {
            commit("AFFTER_DELETED_EDU_LEVEL", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_EDU_LEVELS(state, payload) {
            state.edu_levels = payload;
            state.isReceiving = false;

        },
        RECEIVING_EDU_LEVELS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_EDU_LEVEL(state, payload) {


            if (payload.edu_code == undefined) {
                let error = !payload.e.errorInfo==true?payload.message:payload.e.errorInfo.toString()
                let edu_levelMessage = 'พบข้อผิดพลาด :' + error;
                state = Object.assign(state, {
                    isReceiving: false,
                    edu_levelMessage: (state.edu_levelMessage == edu_levelMessage ? edu_levelMessage + ' ' : edu_levelMessage),

                });
            } else {
                let edu_levelMessage = 'บันทึกสำเร็จ! รายการ ' + payload.edu_code + ' ถูกบันทึกแล้ว';
                
                state = Object.assign(state, {
                    edu_levels: [...state.edu_levels, payload],
                    isReceiving: false,
                    errorMessage: false,
                    edu_levelMessage: (state.edu_levelMessage == edu_levelMessage ? edu_levelMessage + ' ' : edu_levelMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },
        // RECEIVING_EDU_LEVEL(state) {
        //     state.isReceiving = true;
        // },

        UPDATED_EDU_LEVEL(state, payload) {
            let index = state.edu_levels.findIndex(p => p.edu_code === payload.edu_code);
            let edu_levelMessage = 'บันทึกสำเร็จ! รายการ ' + payload.edu_code + ' ถูกแก้ไขแล้ว';
            state = Object.assign(state, {
                edu_levels: state.edu_levels.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                edu_levelMessage: (state.edu_levelMessage == edu_levelMessage ? edu_levelMessage + ' ' : edu_levelMessage),
            })
        },
        UPDATING_EDU_LEVEL(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_EDU_LEVEL(state, payload) {


            if (payload.edu_code == undefined || payload.res.data.message == 'Relation') {
                let edu_levelMessage= 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.edu_code;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                  
                    edu_levelMessage: (state.edu_levelMessage == edu_levelMessage ? edu_levelMessage + ' ' : edu_levelMessage),

                });
            } else {
                let indexToDelete = state.edu_levels.findIndex(p => p.edu_code === payload.edu_code);
                let edu_levels = [...state.edu_levels];
                edu_levels.splice(indexToDelete, 1);
                let edu_levelMessage= 'บันทึกสำเร็จ! รายการ ' + payload.edu_code + ' ถูกลบแล้ว';
                
                state = Object.assign(state, {
                    edu_levels: [...edu_levels],
                    isDeleting: false,
                    idToDelete: null,
                    edu_levelMessage: (state.edu_levelMessage == edu_levelMessage ? edu_levelMessage + ' ' : edu_levelMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_EDU_LEVEL(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.edu_code;
        },
        AFFTER_DELETED_EDU_LEVEL(state) {
            state.errorMessage = false;

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
